<template>
  <div>
    <div class="listContent">
      <div class="searchContent">
        <el-button
          icon="el-icon-plus"
          type="danger"
          @click="openAddBox(activeObj)"
          v-if="userRoleList.indexOf('menu-638e7a91933143b2924d46f9ce8ec802')>-1"
          >添加组织</el-button
        >
        <el-button type="info" @click="deleteSignAll(theCheckObj.officeCode)" plain v-if="userRoleList.indexOf('menu-638e7a91933143b2924d46f9ce8ec802')>-1"
          >删除</el-button
        >
        <span class="searchInputText">组织名称</span>
        <el-input placeholder="请输入设备名称" v-model="search.officeName"></el-input>
        <el-button type="danger" @click="doSearch">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>

      <div class="listContain equipmentList">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            :row-key="fieldKey"
            @selection-change="handleSelectionChange"
            ref="tb"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              prop="officeName"
              label="组织名称"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="code"
              label="用户数"
              width="280"
            ></el-table-column>
            <el-table-column
              prop="leader"
              label="负责人"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="联系电话"
              width=""
            ></el-table-column>
            
            <el-table-column label="操作" width>
              <template slot-scope="scope">
                <span class="lookMore" @click="toInfo(scope.row)"
                  >查看名下设备</span
                >
                <span class="lookMore" @click="openAddBox({ parentCode: scope.row.officeCode, parentName: scope.row.officeName })"
                  >添加子组织</span
                >
                <span class="lookMore" @click="openModbox({ officeCode: scope.row.officeCode, officeName: scope.row.officeName,phone: scope.row.phone,leader: scope.row.leader, })"
                v-if="userRoleList.indexOf('menu-638e7a91933143b2924d46f9ce8ec802')>-1"
                  >修改</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

      <el-dialog
        :title="actionName"
        :visible.sync="addModBoxVisible"
        :close-on-click-modal="false"
        width="400px"
      >
        <div class="borderBlock borderPadding addAndEdit">
          <el-form
            :rules="rules"
            :model="modelObj"
            ref="addModForm"
            label-width="100px"
          >
            <el-form-item label="组织名称" required prop="officeName">
              <el-input
                class="longType"
                v-model="modelObj.officeName"
                maxlength="20"
                placeholder="请输入组织名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="负责人">
              <el-input
                class="shotType"
                v-model="modelObj.leader"
                maxlength="10"
                placeholder="请输入负责人姓名"
              ></el-input>
            </el-form-item>
            
            <el-form-item label="联系电话">
              <el-input
                class="shotType"
                v-model="modelObj.phone"
                maxlength="20"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
            <div style="clear: both"></div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addModBoxVisible = false">取消</el-button>
          <el-button type="primary" @click="addModSubmit">{{
            actionName
          }}</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import {
  fetchDeptList,
  addDept as addPost,
  delDept as delPut,
  modDept as modPut,
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      fieldKey: "officeCode",
      fieldRowName: 'officeName',
      arrowList: [
        {
          name: "组织管理",
          path: "",
        },
        {
          name: "",
          path: "",
        },
      ],
      search: {},
      modelObj: {},
      actionName: '',
      treeList: [],
      dataList: [],
      activeObj: '',
      theCheckObj: '',
      userRoleList: localStorage.getItem("userRoleList")
    };
  },
  computed: {
    rules: function () {
      return {
        officeName: [{ required: true, message: "必填" }, { trigger: "blur" }],
        type: [{ required: true, message: "必填" }],
        code: [{ required: true, message: "必填" }, { trigger: "blur" }],
        targetDuration: [
          { required: true, message: "必填" },
          { trigger: "blur" },
        ],
      };
    },
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.getDataList()
  },
  methods: {
    addPost,
    modPut,
    delPut,
    toInfo: function(e){
      console.log(e)
      this.$router.push({path:'/transfer/equipmentList',query:{officeCode:e.officeCode,officeName:e.officeName}})
    },
    getDataList: function(params) {
      fetchDeptList(params).then(res => {
        console.log(res)
        // let _arr = res.data.content.concat([]);

        // let _getDepts = function(list, _depts) {
        //   for (let i = 0; i < list.length; i++) {
        //     let _m = list[i];
        //     _depts.push({
        //       id: _m.officeCode,
        //       label: _m.officeName,
        //       originalData: _m
        //     });

        //     if (Object.prototype.hasOwnProperty.call(_m, "children") && _m.children.length > 0) {
        //       _depts[_depts.length - 1].children = [];
        //       _getDepts(_m.children, _depts[_depts.length - 1].children);
        //     }
        //   }
        // };
        // let _depts = [];
        // _getDepts(_arr, _depts);
        // this.treeList = _depts;
        this.dataList = res.data.content;
        console.log(this.dataList);
      });
    },
    handleSelectionChange(selection){
      console.log(selection)
      this.theCheckObj = selection[0]
      if(selection.length == 0){
          this.checkedGh = ''
      }else{
          this.checkedGh = selection[0].id;
          this.checkedName = selection[0].sectionName;
          if (selection.length > 1) {
              this.$refs.tb.clearSelection();
              this.$refs.tb.toggleRowSelection(selection.pop());
          }
          
      }
    }
  },
  components: {
    ElPageCover
  },
};
</script>



<style lang="scss" scoped="">
.imgShow {
  height: 950px;
  width: 100%;
  background-image: url("../../images/all/applyImg.png");
  background-size: 100% 100%;
}
.listContent {
  height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  .searchContent {
    height: 70px;
    width: 80%;
    padding: 17.5px 17px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
</style>